Layout.store.state = {
    menuExpanded: false,
    searchVisible: false,
    shoppingCartAmount: 0
};